import { css } from '@emotion/css';
import colors from '@/theme/colors';
import { pxToRem } from '@/utils';

const styles = {
  container: css`
    margin: 0px 16px;
  `,
  content: css`
    display: flex;
    flex-flow: column nowrap;
    min-height: calc(73vh - 56px);
  `,
  formInstruction: css`
    margin-top: 16px;
  `,
  emailContainer: css`
    margin-top: 31px;
  `,
  footer: css`
    display: flex;
    flex-direction: column;
    padding-bottom: 56px;
  `,
  link: css`
    font-family: 'Montserrat Regular';
    font-size: ${pxToRem(14)};
    line-height: 1.43;
    letter-spacing: 0.25px;
    color: ${colors.jungle} !important;
    text-decoration: underline;
    cursor: pointer;
    &:hover,
    &:focus {
      font-weight: bold;
    }
  `,
  secondaryCTA: css`
    margin-top: 12px;
    text-align: center;
  `,
};

export default styles;
